import { api } from './api';

const BASE = 'user';

export const getProfile = () =>
  api.get(`${BASE}/profile`).then(r => r.data);

export const updateProfile = (payload) =>
  api.put(`${BASE}/profile`, payload).then(r => r.data);

export const uploadProfileImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`${BASE}/profile-image`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const getProfileImageUrl = (userId) =>
  `${api.defaults.baseURL}/${BASE}/profile-image/${userId}`;

export const fetchProfileImage = async (userId) => {
  try {
    const response = await api.get(`${BASE}/profile-image/${userId}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  } catch (err) {
    console.error('Failed to fetch profile image:', err);
    return null;
  }
};

export const changePassword = (payload) =>
  api.post(`${BASE}/change-password`, payload).then(r => r.data);
